import { CheckAvailableCreditCTA } from "./ctas";
export var BrandReferralUseCreditIA = function BrandReferralUseCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize), BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return CheckAvailableCreditCTA(strictLocalize);
};
var BRAND_REFERRALS_USE_CREDIT_TITLE = function BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "zvQaIx",
    defaultMessage: [{
      "type": 0,
      "value": "How to use the credit from brand referrals"
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "dkqwac",
    defaultMessage: [{
      "type": 0,
      "value": "After receiving your credit, it’s automatically applied to your next order with any brand – no action required. If you don’t use all your credit at once, any remaining amount will roll over. To check how much credit you have left, go to \"Available credit\" in \"Account\"."
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "DthCDL",
    defaultMessage: [{
      "type": 0,
      "value": "If you’re curious about how much credit you’ve earned from brand referrals, go to \"Refer brands\" in \"Account\" and select the \"Joined\" tab."
    }]
  });
};